module.exports = __webpack_public_path__ + "img/jewelry-m.d4a6856b.png";